export function fixedNumber(value: number, fixed = 2): string {
  if (Number.isNaN(Number(value))) {
    return "0";
  }
  const x = Math.pow(10, fixed);
  const number = Math.floor(value * x) / x;
  const formatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: fixed,
    minimumFractionDigits: fixed,
  });

  return formatter.format(number);
}

export function formatRate(value: number): string {
  if (Number.isNaN(Number(value))) {
    return "0 H/s";
  }

  if (value > 100000000) {
    const v = (value / 1000000000).toFixed(2);
    return `${v} GH/s`;
  }

  const v = (value / 1000000).toFixed(2);
  return `${v} MH/s`;
}
